export const MOVE_REASONS = [
  ["achat", "Achat / réception"],
  ["casse_perte", "Casse / perte"],
  ["correction", "Correction"],
  ["comptage", "Comptage d'inventaire"],
  ["retour", "Retour / réparation"],
  ["autre", "Autre"],
];
export const ALL_REASONS = { ...Object.fromEntries(MOVE_REASONS), import: "Import", creation: "Création" };
export const frDateTime = (iso) => { try { const d = new Date(iso); return `${d.toLocaleDateString("fr-FR")} ${d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}`; } catch { return iso; } };
export const whName = (warehouses, id) => { const w = warehouses.find((x) => x.id === id); return w ? w.name : (warehouses.length ? "Sans entrepôt" : "Global"); };

export function Delta({ d }) {
  return <span className={`font-semibold ${d > 0 ? "text-emerald-400" : "text-red-400"}`}>{d > 0 ? `+${d}` : d}</span>;
}
